import type {DateTimeString, TodoPriority, UserList, UserRef} from "@t/util/CommonTypes.ts";

export type RecurrenceFrequency = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const RecurrenceType = {
	UNSET: 0,
	NO: 1,
	NTH_DAY: 2,
	WORKDAY: 3,
	WEEKLY: 4,
	MONTHLY_EVERY: 5,
	MONTHLY_ALWAYS: 6,
	ANNIVERSARY: 7,
	YEARLY: 8
};

export const AnniversaryType = {
	BIRTHDAY: 1,
	NAMEDAY: 2,
	BIRTHOFCHILD: 3,
	FOUNDATION: 4,
	MARRIAGE: 5,
	OTHERS: 6
}


export interface Recurrence {
	type: RecurrenceFrequency;

	day: number;
	week: number;
	month: number;

	monday: boolean;
	tuesday: boolean;
	wednesday: boolean;
	thursday: boolean;
	friday: boolean;
	saturday: boolean;
	sunday: boolean;


	limit: number;
	occurrence: number;
	dateLimit: DateTimeString;

	anniversary: number;
}


export interface Event extends Recurrence {
	id: number;
	entered?: DateTimeString;
	enteredBy?: UserRef;
	modified?: DateTimeString;
	modifiedBy?: UserRef;
	start?: DateTimeString;
	end?: DateTimeString;
	owners?: UserList;
	responsibles?: UserList;
	specDiary:number;
	private: boolean;
	subject: string;
	description?: string;
	place?: string;
	ringBefore?: number;
	notification?: number;
	completed: boolean;
	completion: "NO"|"YES"|"AUTO"|"CANCEL";
	notifyFlag?: number;
	delegateTime?: DateTimeString;
	agendaCategory?: string;
	symbol?: string;
	collectingFeedback?: boolean;
	priority?: TodoPriority;
	color: number;
	diary: number;
	customer?: number;
	branch?: number;
	person?: number;
	customerFileAs?: string;
	opportunity?: number;
	opportunityName?: string;
	busCase?: number;
	busCaseName?: string;
	problem?: number;
	problemFileAs?: string;
	campaign?: number;
	campaignSymbol?: string;
	project?: number;
	projectName?: string;
	sequence?: number;
	categories: string[];

	repeatId?: number;
	repeat?: Recurrence
}
